export const VIDEOS = {
  openHouse: "/videos/open-house.mp4",
  boutique: "/videos/boutique.mp4",
  conference: "/videos/conference.mp4",
  property: "/videos/property.mp4",
};

export const POSTERS = {
  openHouse: "/posters/open-house.jpg",
  boutique: "/posters/boutique.jpg",
  conference: "/posters/conference.jpg",
  property: "/posters/property.jpg",
};

export const IMAGES = {
  portrait: "https://customer-assets-jai6qajn.emergentagent.net/job_df1f0500-77cc-44b1-b0cc-51603e91ac41/artifacts/35adjda9_08%20photo%20working.jpeg",
};

export const CONTACT = {
  whatsapp: "https://wa.me/17867959800",
  phone: "+1 (786) 795-9800",
  email: "AnklaCreativeStudio@gmail.com",
};

export const translations = {
  en: {
    nav: { work: "Work", process: "Process", founder: "About", contact: "Contact" },
    hero: {
      overline: "Independent Creative Studio — Orlando • Miami",
      titleLines: ["Every brand has a story.", "We help the world", "remember it."],
      studio: "ANKLA Creative Studio",
      tagline: "Stories with intention.",
      by: "by Ginette Figarella",
      cta1: "Start a Project",
      cta2: "View Our Work",
      whatsapp: "WhatsApp",
      videoLabels: ["Luxury Open House", "Boutique", "Conference"],
      scroll: "Slow down. Scroll.",
    },
    mission: {
      overline: "Our Mission",
      lines: ["Your brand already has a story to tell.", "Let's make people connect with it."],
      text: "Not a logo. Not a strategy. Something human — something that exists before a camera is ever turned on.",
    },
    work: {
      overline: "Selected Work",
      title: "Our Work",
      watch: "Watch with sound",
      close: "Close",
      items: [
        { title: "Real Estate", category: "Real Estate", year: "2025" },
        { title: "Boutique", category: "Retail", year: "2025" },
        { title: "Conference", category: "Events", year: "2024" },
        { title: "Real Estate", category: "Real Estate", year: "2025" },
      ],
    },
    process: {
      overline: "How We Work",
      chapters: [
        {
          title: "We discover the essence of your brand.",
          text: "Before creating any story, we take the time to understand what makes your business unique, what it represents and how you want people to remember it.",
        },
        {
          title: "We understand its story.",
          text: "Every brand has a reason for being. We uncover that story and find the best way to tell it so it can connect authentically with people.",
        },
        {
          title: "We transform it into an audiovisual story.",
          text: "We bring that essence to life through image, movement and sound, creating a piece that represents your brand authentically and leaves a lasting impression.",
        },
      ],
    },
    founder: {
      overline: "About the Founder",
      name: "Ginette Figarella",
      role: "Founder & Creative Director",
      body: "ANKLA is an independent creative studio led by Ginette Figarella. It was founded on a simple belief: every business has a personality, and every person deserves to be seen for who they truly are. Ginette works closely with each client — in English and Spanish, between Orlando and Miami.",
      caption: "On set — a story being revealed.",
      locations: "Orlando • Miami",
      languages: "English • Español",
    },
    contact: {
      overline: "Contact",
      title: "Start a project.",
      sub: "Tell us about your story — or simply say hello. We answer personally, within one business day.",
      whatsappLabel: "WhatsApp",
      emailLabel: "Email",
      name: "Your name",
      email: "Your email",
      company: "Your company (optional)",
      message: "What story is waiting to be revealed?",
      submit: "Send Inquiry",
      sending: "Sending…",
      success: "Thank you. Your story has reached us — check your inbox.",
      error: "Something went wrong. Please try again.",
      locations: "Orlando • Miami",
      languages: "English • Español",
      founder: "Creative Direction by Ginette Figarella",
      rights: "ANKLA Creative Studio. All stories reserved.",
    },
  },
  es: {
    nav: { work: "Trabajo", process: "Proceso", founder: "Nosotros", contact: "Contacto" },
    hero: {
      overline: "Estudio Creativo Independiente — Orlando • Miami",
      titleLines: ["Toda marca tiene una historia.", "Nos aseguramos de que sea", "imposible olvidarla."],
      studio: "ANKLA Creative Studio",
      tagline: "Historias con intención.",
      by: "por Ginette Figarella",
      cta1: "Iniciar un Proyecto",
      cta2: "Ver Nuestro Trabajo",
      whatsapp: "WhatsApp",
      videoLabels: ["Open House de Lujo", "Boutique", "Conferencia"],
      scroll: "Respira. Desliza.",
    },
    mission: {
      overline: "Nuestra Misión",
      lines: ["Tu marca ya tiene una historia que contar.", "Hagamos que las personas conecten con ella."],
      text: "No un logo. No una estrategia. Algo humano — algo que existe antes de que una cámara se encienda.",
    },
    work: {
      overline: "Trabajo Seleccionado",
      title: "Nuestro Trabajo",
      watch: "Ver con sonido",
      close: "Cerrar",
      items: [
        { title: "Real Estate", category: "Bienes Raíces", year: "2025" },
        { title: "Boutique", category: "Retail", year: "2025" },
        { title: "Conferencia", category: "Eventos", year: "2024" },
        { title: "Real Estate", category: "Bienes Raíces", year: "2025" },
      ],
    },
    process: {
      overline: "Cómo Trabajamos",
      chapters: [
        {
          title: "Descubrimos la esencia de tu marca.",
          text: "Antes de crear cualquier historia, entendemos qué hace única a tu empresa, qué representa y cómo quieres que las personas la recuerden.",
        },
        {
          title: "Entendemos su historia.",
          text: "Toda marca tiene una razón de ser. Descubrimos esa historia y encontramos la mejor forma de contarla para conectar de manera auténtica con las personas.",
        },
        {
          title: "La transformamos en una historia audiovisual.",
          text: "Convertimos esa esencia en una historia que cobra vida a través de imágenes, movimiento y sonido, creando una pieza que representa tu marca de forma auténtica y deja una impresión duradera.",
        },
      ],
    },
    founder: {
      overline: "Sobre la Fundadora",
      name: "Ginette Figarella",
      role: "Fundadora y Directora Creativa",
      body: "ANKLA es un estudio creativo independiente dirigido por Ginette Figarella. Fue fundado sobre una creencia simple: todo negocio tiene una personalidad, y toda persona merece ser vista por quien realmente es. Ginette trabaja de cerca con cada cliente — en inglés y español, entre Orlando y Miami.",
      caption: "En el set — una historia siendo revelada.",
      locations: "Orlando • Miami",
      languages: "English • Español",
    },
    contact: {
      overline: "Contacto",
      title: "Inicia un proyecto.",
      sub: "Cuéntanos tu historia — o simplemente saluda. Respondemos personalmente, en un día hábil.",
      whatsappLabel: "WhatsApp",
      emailLabel: "Email",
      name: "Tu nombre",
      email: "Tu correo",
      company: "Tu empresa (opcional)",
      message: "¿Qué historia espera ser revelada?",
      submit: "Enviar Consulta",
      sending: "Enviando…",
      success: "Gracias. Tu historia nos ha llegado — revisa tu correo.",
      error: "Algo salió mal. Inténtalo de nuevo.",
      locations: "Orlando • Miami",
      languages: "English • Español",
      founder: "Creative Direction by Ginette Figarella",
      rights: "ANKLA Creative Studio. Todas las historias reservadas.",
    },
  },
};
